import { useState } from "react";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function LineBulkEditDialog({ open, onOpenChange, count, costCodes, onApply }) {
  const [form, setForm] = useState({});
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const apply = async () => {
    const payload = {};
    if (form.section !== undefined && form.section !== "") payload.section = form.section;
    if (form.material_gm_percent) payload.material_gm_percent = parseFloat(form.material_gm_percent) / 100;
    if (form.labor_gm_percent) payload.labor_gm_percent = parseFloat(form.labor_gm_percent) / 100;
    if (form.cost_code_id) payload.cost_code_id = form.cost_code_id;
    if (form.is_option !== undefined) payload.is_option = form.is_option === "yes";
    if (form.is_excluded !== undefined) payload.is_excluded = form.is_excluded === "yes";
    await onApply(payload);
    setForm({});
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="line-bulk-dialog">
        <DialogHeader><DialogTitle>Bulk edit {count} line(s)</DialogTitle></DialogHeader>
        <div className="space-y-2.5">
          <div>
            <label className="text-[11px] text-slate-500">Move to section</label>
            <Input value={form.section || ""} onChange={(e) => set("section", e.target.value)}
                   className="h-8 text-xs" placeholder="Leave blank to keep"
                   data-testid="bulk-section" />
          </div>
          <div className="flex gap-2">
            <div className="flex-1">
              <label className="text-[11px] text-slate-500">Material GM %</label>
              <Input type="number" value={form.material_gm_percent || ""}
                     onChange={(e) => set("material_gm_percent", e.target.value)}
                     className="h-8 text-right text-xs" data-testid="bulk-material-gm" />
            </div>
            <div className="flex-1">
              <label className="text-[11px] text-slate-500">Labor GM %</label>
              <Input type="number" value={form.labor_gm_percent || ""}
                     onChange={(e) => set("labor_gm_percent", e.target.value)}
                     className="h-8 text-right text-xs" data-testid="bulk-labor-gm" />
            </div>
          </div>
          <div>
            <label className="text-[11px] text-slate-500">Cost code</label>
            <select value={form.cost_code_id || ""} onChange={(e) => set("cost_code_id", e.target.value)}
                    className="h-8 w-full rounded border border-slate-200 bg-white px-2 text-xs"
                    data-testid="bulk-cost-code">
              <option value="">Keep current</option>
              {(costCodes || []).map((c) => (
                <option key={c.id} value={c.id}>{c.code} — {c.name}</option>
              ))}
            </select>
          </div>
          <div className="flex gap-2">
            <div className="flex-1">
              <label className="text-[11px] text-slate-500">Alternate</label>
              <select value={form.is_option ?? ""} onChange={(e) => set("is_option", e.target.value)}
                      className="h-8 w-full rounded border border-slate-200 bg-white px-2 text-xs"
                      data-testid="bulk-is-option">
                <option value="">Keep</option>
                <option value="yes">Mark as alternate</option>
                <option value="no">Base scope</option>
              </select>
            </div>
            <div className="flex-1">
              <label className="text-[11px] text-slate-500">Excluded</label>
              <select value={form.is_excluded ?? ""} onChange={(e) => set("is_excluded", e.target.value)}
                      className="h-8 w-full rounded border border-slate-200 bg-white px-2 text-xs"
                      data-testid="bulk-is-excluded">
                <option value="">Keep</option>
                <option value="yes">Exclude</option>
                <option value="no">Include</option>
              </select>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}
                  data-testid="bulk-cancel">Cancel</Button>
          <Button onClick={apply} data-testid="bulk-apply">Apply to {count} line(s)</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
